import React, { useEffect, useState } from "react";
import FormInputText from "../common/FormInputText";
import Button from "../common/button/Button";
import ButtonType from "../common/button/ButtonType";
import ButtonAction from "../common/button/ButtonAction";
import { useApiClient } from "../../contexts/ApiClientContext";
import AnnexData from "../../model/AnnexData";
import PagedData from "../../model/PagedData";
import APIEndPoints from "../../utils/APIEndPoints";
import TimeUtil from "../../utils/TimeUtil";

interface Props {
  id_chelement: number;
  id_e3d: number;
  activeTab: string;
  hint?: string;
  selectedReferences: AnnexData[];
  onSetSelectedReferences: (references: AnnexData[] | []) => void;
}

const ConditionReportAddEdit_references: React.FC<Props> = ({
  id_chelement,
  id_e3d,
  activeTab,
  hint,
  selectedReferences,
  onSetSelectedReferences,
}) => {
  // reference to the ApiClient instance
  const apiClient = useApiClient();

  // State for managing the input value
  const [inputValue, setInputValue] = useState("");
  const [references, setReferences] = useState<AnnexData[]>([]);
  const [displayedReferences, setDisplayedReferences] = useState<AnnexData[]>(
    [],
  );

  const [selectedReferenceObjects, setSelectedReferenceObjects] = useState<
    AnnexData[]
  >([]);
  const [showMore, setShowMore] = useState(false);

  useEffect(() => {
    // console.log("ch: " + id_chelement + "; e3d: " + id_e3d)
    function loadReferences() {
      let loaded_annex_data: AnnexData[] = [];
      // Load Chelement's AnnexData
      apiClient
        ?.get<PagedData<AnnexData[]>>({
          url: APIEndPoints.ANNEXDATA.ALL(id_chelement, undefined, undefined),
          requiresToken: true,
        })
        .then((response: PagedData<AnnexData[]>) => {
          const items = response.items;
          loaded_annex_data.push(...items);

          // Now load the e3D's AnnexData, and join them in the same list
          apiClient
            ?.get<PagedData<AnnexData[]>>({
              url: APIEndPoints.ANNEXDATA.ALL(undefined, undefined, id_e3d),
              requiresToken: true,
            })
            .then((response: PagedData<AnnexData[]>) => {
              const items = response.items;
              loaded_annex_data.push(...items);

              setReferences(loaded_annex_data);

              // filterSearchReferences();
              // Now load the e3D's AnnexData, and join them in the same list

              // setReferences(items);

              // setShowMore(items.length > 4);
            })
            .catch(() => {
              // navigate(SETTINGS.get_path({ section: AppSections.SIGN_IN }));
            })
            .finally(() => {
              // setLoading(false);
            });
        })
        .catch(() => {
          // navigate(SETTINGS.get_path({ section: AppSections.SIGN_IN }));
        })
        .finally(() => {
          // setLoading(false);
        });
    }

    loadReferences();
  }, [apiClient]);

  useEffect(() => {
    // Trigger re-render when parent updates selected references
    setDisplayedReferences((prev) => [...prev]);
  }, [selectedReferences]);

  useEffect(() => {
    filterSearchReferences();

    // console.log("References:==============================")
    // console.log(references)
    // console.log("----------------")
    // console.log(selectedReferences)
  }, [inputValue, references]);

  // Add this function to handle annotation removal
  const removeSelectedAnnotation = (id: number) => {
    onClickReferenceCard(id);
  };

  const handleShowMore = () => {
    setShowMore(false);
    setDisplayedReferences(references);
  };

  const filterSearchReferences = () => {
    const filtered = references.filter((ref) =>
      ref.title.toLowerCase().includes(inputValue.toLowerCase()),
    );
    // setDisplayedAnnotation(filtered);
    if (filtered.length > 4) {
      setShowMore(true);
      setDisplayedReferences(filtered.slice(0, 4));
    } else {
      setShowMore(false);
      setDisplayedReferences(filtered);
    }
  };

  const handleInputChange = (id: string, value: string) => {
    setInputValue(value);
    filterSearchReferences();
  };

  const onClickReferenceCard = (id: number) => {
    if (selectedReferences.find((ref) => ref.id === id)) {
      onSetSelectedReferences(
        selectedReferences.filter((refId) => refId.id !== id),
      );
    } else {
      onSetSelectedReferences([
        ...selectedReferences,
        references.find((ref) => ref.id === id)!,
      ]);
    }
  };

  return (
    <>
      <label className="form-label">References:</label>
      {hint && <div className="form-hint">{hint}</div>}
      
      <div className="form-input-group-vertical">
        <div>
          <FormInputText
            label="Filter References by keyword:"
            id="name"
            value={inputValue}
            placeholder="Reference Name"
            onChange={handleInputChange}
            
          />
        </div>
        {/* <p className="text-sm text-gray-600 mt-2">You typed: {inputValue}</p> */}

        {/* Associated References */}
        <div
          className="details-section"
          key={activeTab + "-" + selectedReferences.join("-")}
        >
          {/* <h4>Matching References:</h4> */}
          {references.length === 0 && <p>No References to select from...</p>}
          {references.length > 0 && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 m-4">
              {displayedReferences.map((reference) => (
                <div
                  key={reference.id}
                  id={`reference-${reference.id}`}
                  className={`bg-white shadow rounded-lg p-4 cursor-pointer transition-colors duration-200 ${
                    selectedReferences.some((ref) => ref.id === reference.id)
                      ? "bg-green-100 !important"
                      : "bg-white"
                  }`}
                  style={{
                    backgroundColor: selectedReferences.some(
                      (ref) => ref.id === reference.id,
                    )
                      ? "#d4edda"
                      : "white",
                  }}
                  onClick={() => onClickReferenceCard(reference.id!)}
                  onMouseOver={() =>
                    console.log(
                      `Hovering over annotation ${reference.id}, class:`,
                      document.getElementById(`reference-${reference.id}`)
                        ?.className,
                    )
                  }
                >
                  <h3 className="text-sm font-semibold mb-2">
                    {reference.title}
                  </h3>
                  {/* <p className="text-xs text-gray-500">
                           {reference.content}
                        </p> */}
                  <p className="text-xs text-gray-500">
                    Type: {reference.category}
                  </p>

                  <p className="text-xs text-gray-500">
                    {/* {AppIcons.CLOCK} */}
                    {TimeUtil.display_date(reference.timestamp)}
                  </p>
                </div>
              ))}

              {showMore && (
                <div className="details-show-more">
                  <Button
                    label="Show all References"
                    onClick={handleShowMore}
                    purpose={ButtonAction.UPDATE}
                  />
                </div>
              )}
            </div>
          )}
        </div>

        <h4>Selected References:</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {selectedReferences &&
            selectedReferences.length > 0 &&
            selectedReferences.map((ref) => {
              return (
                <div
                  className="details-grid-element flex flex-row items-center justify-between"
                  key={ref.id}
                >
                  <span className="truncate">{ref.title}</span>
                  <Button
                    type={ButtonType.ICON}
                    purpose={ButtonAction.DELETE}
                    label=""
                    onClick={() => {
                      removeSelectedAnnotation(ref.id!);
                    }}
                  />
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default ConditionReportAddEdit_references;
